// FILE: src/components/ProgressRing.js
//
// Reusable SVG progress ring used by the Readiness Hero (big) and the
// Milestones-at-a-Glance card (small). Pure SVG, no canvas, no deps.
//
//   <ProgressRing value={67} size={200} stroke={14}>
//     <span className="big">67</span>
//     <span className="small">/100</span>
//   </ProgressRing>

import React from 'react';
import styles from './ProgressRing.module.css';

export default function ProgressRing({
  value,                 // 0..100
  size = 200,
  stroke = 14,
  color = '#2c63ff',
  trackColor = '#e5e8f1',
  className = '',
  children,
}) {
  const pct  = Math.max(0, Math.min(100, Number(value) || 0));
  const r    = (size - stroke) / 2;
  const c    = 2 * Math.PI * r;
  const off  = c * (1 - pct / 100);

  return (
    <div className={[styles.ring, className].filter(Boolean).join(' ')} style={{ width: size, height: size }}>
      <svg viewBox={`0 0 ${size} ${size}`} className={styles.svg}>
        <circle cx={size / 2} cy={size / 2} r={r}
          fill="none" stroke={trackColor} strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r}
          fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={off} />
      </svg>
      <div className={styles.label}>{children}</div>
    </div>
  );
}
